// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Bb7","col":"styles_col__10rjc"};